<template>
  <stu-main @back="goBack">
    <template slot="nav">
      <div class="stuNav">
        <p @click="changeIdx(1)" :class="idx === 1 ? 'active': ''" style="margin-right: 20px">{{userType !=='qualificationInquire' ? '学员':'教练员'}}查询</p>
        <p @click="changeIdx(2)" :class="idx === 2 ? 'active': ''" v-if="userType !=='qualificationInquire'">学员管理（已成功注册）</p>
        <p @click="goPlayer" v-if="!isFive && userType !=='qualificationInquire'" >高水平职业球员认证</p>
        <p @click="goCoach_export" v-if="!isFive && ['system','super'].includes(userType)" >信息导出</p>
      </div>
    </template>
    <template slot="main">
      <div class="stuMain" v-show="idx === 2">
        <div class="searchWrap">
          <div class="selectWrap">
            <select v-model="search.train_time"
                    @change="getRequest">
              <option value="">全部培训日期</option>
              <option v-for="(item, index) in filterData.date"
                      :key="index"
                      :value="item.value">{{ item.key }}
              </option>
            </select>
            <select v-model="search.org_id"
                    @change="getClassList(true)">
              <option value="">全部机构</option>
              <option v-for="(item, index) in orgListArr"
                      :key="index"
                      :value="item.org_id">{{ item.name }}
              </option>
            </select>
            <select v-model="search.c_id"
                    @change="getRequest">
              <option value="">全部培训班</option>
              <option v-for="(item, index) in classListArr"
                      :key="index"
                      :value="item.c_id">{{item.start_date_two}}年 {{item.class_level | classInfoBoxLevelFilter(isFive)}}级 第{{ item.periods }}期 （{{item.class_train_type === 'continue_education' ? '继续教育' : '等级培训'}}）
              </option>
            </select>
            <select v-model="search.is_high_player"
                    @change="getRequest" v-if="!isFive">
              <option value="">全部学员</option>
              <option value="1">高水平职业球员</option>
            </select>
          </div>
          <div class="search">
            <div class="wrap">
              <input v-model.lazy="search.user_name"
                type="text"
                placeholder="请输入搜索内容"
                @keyup.enter="getRequest">
              <div v-show="search.user_name!=''"
                class="close"
                @click="hideIcon">
                <v-icon name="regular/times-circle"
                  scale="1.2"></v-icon>
              </div>
            </div>
            <div class="searchBtn"
                 @click="getRequest">搜索
            </div>
          </div>
        </div>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
          <template v-if="showList">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th index"><strong>序号</strong></div>
                  <div class="th name"><strong>学员姓名</strong></div>
                  <div class="th gender"><strong>性别</strong></div>
                  <div class="th tel"><strong>学员联系电话</strong></div>
                  <div class="th IDcard"><strong>身份有效证件号</strong></div>
                  <div class="th Info"><strong>信息状态</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div v-if="showList"
                   class="scrollArea">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div class="tr"
                           v-for="(item, index) in list"
                           :key="index">
                        <div class="td index">
                          <p>{{ index+1 }}</p>
                        </div>
                        <div class="td name">
                          <p :style="{color:item.is_high_player ? '#f88594' : '#FFFFFF'}" :title="item.is_high_player ? '高水平职业球员认证' : ''">{{ item.user_name }}</p>
                        </div>
                        <div class="td gender">
                          <p>{{ item.gender == "Male" ? "男" : "女" }}</p>
                        </div>
                        <div class="td tel">
                          <p>{{ item.mobile_phone }}</p>
                        </div>
                        <div class="td IDcard">
                          <p>{{ item.id_number || "--" }}</p>
                        </div>
                        <div class="td Info">
                          <p>{{ item.student_information == "Active" ? "完成" : "未完善" }}</p>
                        </div>
                        <div class="td opt">
                          <span @click="lookOver(item.uid)">查看</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <div id="paging">
              <yioks-paging :paging="paging"
                            @goto-page="gotoPage($event)"></yioks-paging>
            </div>
          </template>
          <yioks-empty v-show="showEmpty"></yioks-empty>
        </template>
      </div>
      <stu-search v-show="idx === 1" />
      <!--<AuthenticationList v-show="idx === 3" />-->
    </template>
  </stu-main>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import {stuList, orgList} from "@/api/system_manager/api";
  import {date} from "@/assets/js/select";
  import fiveMixins from '@/minix/fiveMixins';
  import { storageData } from "@/assets/js/storage";

  export default {
    name: "Student",
    mixins: [ fiveMixins ],
    data() {
      return {
        userType:storageData.getUserType(),
        ops: ops(),
        isLoading: true,
        showList: false,
        showEmpty: false,
        page: 1,
        list: [],
        orgListArr: [],
        classListArr: [],
        paging: {
          start: 0,
          prePage: 1,
          total: 30,
          size: 3,
          last: true,
          next: true,
          first: true,
          previous: true,
          jump: true
        },
        search: {
          train_time: "",
          org_id: "",
          c_id: "",
          user_name: "",
          is_high_player: "",
        },
        filterData: {
          date: date,
        },
        idx: 1
      }
    },
    components: {
      "stu-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-paging": () => import("@/components/Pagination/Page"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "stu-search": () => import("./stu-search"),
      "AuthenticationList": () => import("@/components/highPlayerAuthentication/AuthenticationList")
    },
    created() {
      this.idx = this.$route.query.idx * 1 || 1
      if(this.userType !=='qualificationInquire'){
        this.setData();
        this.getStuList();
      }
      
    },
    methods: {
      setData() {
        // console.log(this.$route.query);
        const {page, time, org, cid, name,is_high_player} = this.$route.query;
        page && (this.page = page);
        time && this.$set(this.search, "train_time", time);
        is_high_player && this.$set(this.search, "is_high_player", is_high_player);
        this.getOrgList();
        org && this.$set(this.search, "org_id", org);
        org && this.getClassList(false);
        cid && this.$set(this.search, "c_id", cid);
        name && this.$set(this.search, "user_name", name);
      },
      goBack() {
        this.$router.push('/system/sm');
      },
      getStuList() {
        this.isLoading = true;
        stuList({"page": this.page, ...this.search})
          .then((res) => {
            this.isLoading = false;
            // console.log(res);
            const {list, page} = res.data.result;
            this.$set(this.paging, "prePage", page.page_size);
            this.$set(this.paging, "total", page.total_row);
            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
            this.list = list;
            this.showList = Boolean(list.length > 0);
            this.showEmpty = !this.showList;
          })
          .catch((err) => {
            this.isLoading = false;
            console.log(err);
          });
      },
      getOrgList() {
        orgList({})
          .then((res) => {
            this.orgListArr = res.data.result.organization;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      getClassList(flag) {
        // flag 为了解决一个隐藏bug，想知道什么bug自己看
        if(flag) {
          this.$set(this.search, "c_id", "");
          this.getRequest();
        }
        orgList({"org_id": this.search.org_id})
          .then((res) => {
            this.classListArr = res.data.result.classTrain;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      hideIcon() {
        this.$set(this.search, "user_name", "");
        this.getRequest();
      },
      gotoPage: function (start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
        this.$refs['vs'].scrollTo({ y: 0 });
      },
      getRequest() {
        this.changeQuery(true);
      },
      changeQuery(flag) {
        flag && (this.page = 1);
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            page: this.page,
            time: this.search.train_time,
            is_high_player: this.search.is_high_player,
            org: this.search.org_id,
            cid: this.search.c_id,
            name: this.search.user_name,
          }
        });
        this.getStuList();
      },
      lookOver(id) {
        // this.$router.push({path: 'od', query: {id: id}});
        this.$router.push({path: 'st', query: {id: id}});
      },
      changeIdx(idx) {
        if (this.idx === idx) return
        this.$router.replace({
          path: this.$route.path,
          query:{
            ...this.$route.query,
            idx
          }
        })
        this.idx = idx
      },
      goPlayer(){
        this.$router.push({
          path: "authenticationList",
        });
      },
      goCoach_export(){
        this.$router.push({
          path: "coachExport",
        });
      }
      
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .stuNav, .stuMain {
    flex: 1 1 auto;
    height: 100%;
  }

  .stuNav {
    display: flex;
    align-items: center;
    font-size: 18px;
    p{
      padding: 8px 15px;
      cursor: pointer;
      &.active{
        background: $color_suc;
      }
    }
  }

  .stuMain {
    width: 100%;
    padding: 25px 0 0;
    background-color: $block_bg_color_base;
    .searchWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      margin: 0 40px;
      .selectWrap {
        height: 100%;
        display: flex;
        align-items: center;
        select {
          width: 120px;
          height: 100%;
          padding: 0 10px;
          margin: 0 10px 0 0;
          font-size: $font_size_medium;
          color: $color_black;
          outline: none;
        }
      }
      .search {
        height: 100%;
        display: flex;
        align-items: center;
        .wrap {
          height: 100%;
          position: relative;
          input {
            width: 200px;
            height: 100%;
            padding: 0 20px;
            font-size: $font_size_medium;
            color: $color_black;
            outline: none;
          }
          .close {
            position: absolute;
            right: 5px;
            top: 10px;
            color: $color_info;
            cursor: pointer;
          }
        }
        .searchBtn {
          width: 90px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          background-color: $color_suc;
          cursor: pointer;
        }
      }
    }
    .table {
      width: 100%;
      margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 401px;
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width: 810px;
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        flex: 1 1 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td:last-child, .td.num {
        color: $color_suc;
        user-select: none;
      }
      .td {
        p {
          over_hide();
        }
      }
      .index {
        width: 6%;
      }
      .name {
        width: 18%;
      }
      .gender {
        width: 10%;
      }
      .tel {
        width: 17%;
      }
      .IDcard {
        width: 27%;
      }
      .Info {
        width: 11%;
      }
      .opt {
        width: 11%;
        span {
          cursor: pointer;
        }
      }
    }
    #paging {
      width: 100%;
      height: 77px;
    }
  }
</style>
